import { useTranslation } from 'react-i18next';

import { EnvVariable, ModalName } from '../../../../../enums';
import { useOpenModal } from '../../../../../features/modals';
import { useAnyFiltersActive } from '../../../../../features/patients';
import { getBooleanEnvVariable } from '../../../../../utils';
import { Button } from '../../../../common';
import { EmptyState } from '../../../empty-state';
import { EmptyPatientsImage } from '../../../images';

export const NoPatients = () => {
  const { t } = useTranslation();
  const openInvitePatientModal = useOpenModal(ModalName.INVITE_PATIENT);
  const anyFiltersActive = useAnyFiltersActive();
  const canInvitePatient = getBooleanEnvVariable(EnvVariable.USE_INVITE_PATIENT);

  return (
    <EmptyState
      image={<EmptyPatientsImage />}
      title={t(`patients.empty.title.${anyFiltersActive ? 'noResult' : 'noPatients'}`)}
      subtitle={anyFiltersActive && t('patients.empty.subtitle.noResult')}
    >
      {canInvitePatient && !anyFiltersActive && (
        <Button
          className="mt-6"
          text={t('patients.button.invite')}
          size="sm"
          onClick={() => openInvitePatientModal()}
        />
      )}
    </EmptyState>
  );
};
